// extracted by mini-css-extract-plugin
module.exports = {"center":"AssetProviderPage_center__2zzuz"};